module.exports = __webpack_public_path__ + "static/media/waves.4626d6a0.svg";